import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import {
  CropConnectLanguages,
  cropConnectApiClient,
} from '../services/cropConnectApiClient';
import { useContextStore } from './contextStore';

export interface ProfileState {
  userLanguage: CropConnectLanguages;
  changeUserLanguage: (language: CropConnectLanguages) => Promise<void>;
}

export const useProfileStore = create<ProfileState>()(
  devtools((set) => ({
    userLanguage: useContextStore.getState()
      .selectedUserLanguage as CropConnectLanguages,

    changeUserLanguage: async (language: CropConnectLanguages) => {
      const response = await cropConnectApiClient.changeMyLanguage(language);
      if (response.success) {
        await useContextStore.getState().fetchContext();
        set({
          userLanguage: useContextStore.getState()
            .selectedUserLanguage as CropConnectLanguages,
        });
      } else {
        console.error('Error changing language on server:', response.error);
      }
    },
  }))
);
